import React from 'react';
import bemBlock from '@gik/core/utils/bemBlock';
import HomepageHeader from '@gik/homepage/components/HomepageHeader/HomepageHeader';
import Benefits from '@gik/homepage/components/Benefits/Benefits';
import HeroComputer from '@gik/homepage/components/HeroComputer/HeroComputer';
import StartInkind from '@gik/homepage/components/StartInkind/StartInkind';
import Create from '@gik/homepage/components/Create/Create';
import Features from '@gik/homepage/components/Features/Features';
import { InkindUsesSection } from '@gik/marketing';
import { HomepageStructuredData } from '@gik/seo';

const blockName = 'homepage';

export default function Homepage() {
  const bem = bemBlock(blockName);

  return (
    <HomepageStructuredData>
      <article className={bem()}>
        <HomepageHeader />
        <Features />
        <Benefits />
        <HeroComputer />
        <StartInkind />
        <InkindUsesSection cols={4} perPage={4} />
        <Create />
      </article>
    </HomepageStructuredData>
  );
}
